import { useLocation, useNavigate, useParams } from "react-router-dom";
import Button from "../components/Button";
import ModalPage from "../components/ModalPage";
import { useTranslation } from "react-i18next";

const SubmittedScreen = (props: { title: string, text: string }) => {
    const { title, text } = props;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();
    const { returnTab, applicationId: stateAppId } = (location.state ?? {}) as { returnTab?: string; applicationId?: number };

    return (
        <ModalPage
            showCheck={true}
        >
            <h2>{title}</h2>
            <p className="my-3">{text}</p>
            <Button
                title={t('close')}
                type="primary"
                onClick={() => {
                    const appId = stateAppId ?? params.id;
                    const tab = returnTab ?? 'rapporter';
                    navigate(appId ? `/soknad/${appId}/${tab}` : '/din-side');
                }}
            />
        </ModalPage>
    )
}

export default SubmittedScreen;